import React, { Fragment } from 'react'
import { CssBaseline, Box } from '@material-ui/core'
import Hidden from '@material-ui/core/Hidden'
import { useTheme } from '@material-ui/styles'

import { usePageId } from '@seasonedsoftware/utils'
import PageTitle from 'core/PageTitle'
import AppBar from 'ui/header/AppBar'
import Footer from 'ui/NewFooter'

const Layout = props => {
  const { title, location, children, layoutStyle } = props
  const id = usePageId(location)
  const theme = useTheme()

  const [amazonPathname] = location.pathname.match(/amazon-subscribe/) || []

  return (
    <Fragment>
      <Box
        css={{
          width: '100%',
        }}
      >
        <AppBar location={location} />
        <Box
          component="section"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            padding: theme.spacing(10, 0, 0, 0),
            ...layoutStyle,
          }}
          id={id}
        >
          <CssBaseline />
          {title && <PageTitle>{title}</PageTitle>}
          {children}
        </Box>
      </Box>
      <Footer oldVersion />

      {amazonPathname === 'amazon-subscribe' && (
        <React.Fragment>
          <Hidden only={['xs', 'md', 'lg', 'xl']}>
            <div style={{ height: 258 }}></div>
          </Hidden>
          <Hidden smUp>
            <div style={{ height: 236 }}></div>
          </Hidden>
        </React.Fragment>
      )}
    </Fragment>
  )
}

export default Layout
